<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Refunded</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <b>Refunded</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">

        <p>The page allow to view any refunded items.</p>

        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">

            <h4 class="card-title mb-3">Refunded</h4>

            <!-- Vendor -->
            <div class="table-responsive">
              <table
                id="refund_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Prices ($)</th>
                    <th>Date</th>
                    <th>Refunded By</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(refund, index) in refunds" v-bind:key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ refund.price_redeemed }}</td>
                    <td>{{ refund.updated_at | moment("Do MMMM YYYY, h:mm a") }}</td>
                    <td>{{ refund.balance[0].account_number }}</td>

                    <td>
                      <!-- <router-link :to="redirect(refund.id)" type="button" class="btn btn-success btn-rounded btn-block" style="background-color: #78BE20; border-color: #78BE20;">
                          Edit Details
                        </router-link> -->

                        <router-link class="btn btn-primary btn-rounded btn-block" :to="action(refund.id)">
                              View Details
                          </router-link>

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


    <script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "vendor-redeem-view",
  components: {},

  data() {
    return {
      refunds: []
    };
  },

  methods: {
    loadRefunds() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/transaction/refund", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.refunds = res.data.refunds;
            
          })
          .then(function() {
              $("#refund_tbl").DataTable({
                    "pageLength": 5,
                    dom: "Bfrtip",
                    buttons: ["excel", "pdf"]
                });
          })
      }
    },

    action(id){
        return "/refund/summary/" + id
    },

    loadData(){
        this.destroyDatatable()
        this.loadRefunds()
    },

    destroyDatatable() {
      $("#refund_tbl").DataTable().destroy();
    },
    
    redirect(id) {
      return "/faq/update/" + id;
    }
  },

  mounted() {
    this.loadData();
  }
};
</script>
